module.exports = __webpack_public_path__ + "media/retinus-pvp-demo-video3.93a8ff97.mp4";